import { useContext } from 'react';
import { StoreMetricsContext } from './StoreMetricsContext';

export const useStoreMetrics = () => {
  const context = useContext(StoreMetricsContext);

  if (context === undefined) {
    throw new Error('useStoreMetrics must be within the Context Provider');
  }
  return context;
};
